export default __webpack_public_path__ + "images/ce250a092798cec13937b907a194e771.svg";